module.exports = __webpack_public_path__ + "static/media/calendar.3342c039.svg";